module.exports = __webpack_public_path__ + "img/ETHEREUM-ICON_Black_small.eb93c8ed.png";